<template>
  <TooltipSelector
    ref="tooltipSelector"
    v-model="internalValue"
    :options="options"
    :disable-pro-options="disableProOptions"
    :upgrade-intent="upgradeIntent"
    :append-to-body="appendToBody"
    @upgrade="upgrade"
  >
    <template v-if="!compact" v-slot:trigger="{currentOption}">
      <b-button class="selector-trigger-wrapper">
        <div :class="iconWrapperClass" class="tooltip-selector-icon-wrapper">
          <TooltipSelectorOptionIcon :option="currentOption" class="selector-trigger" />
          <ProTagWithUpgradeTooltip
            v-if="currentOption?.isPro"
            @upgrade="upgrade"
            :upgrade-intent="upgradeIntent"
            class="tooltip-selector-pro-tag"
          />
        </div>
        <div class="selector-trigger-label">{{ currentOption?.label }}</div>
      </b-button>
    </template>
  </TooltipSelector>
</template>

<script>
import TooltipSelector from '@/components/decks/TooltipSelector.vue'
import ProTagWithUpgradeTooltip from '~/components/upgrade/ProTagWithUpgradeTooltip'
import TooltipSelectorOptionIcon from '~/components/decks/tooltip-selector/TooltipSelectorOptionIcon'

export default {
  name: 'TooltipSelectorMixin',
  components: { TooltipSelectorOptionIcon, ProTagWithUpgradeTooltip, TooltipSelector },
  props: {
    value: {
      type: String,
      default: null
    },
    disableProOptions: {
      type: Boolean,
      default: false
    },
    upgradeIntent: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    iconWrapperClass: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: null,
      options: []
    }
  },
  watch: {
    value (val) {
      this.internalValue = val
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.internalValue = this.value
  },
  methods: {
    upgrade () {
      this.$refs.tooltipSelector.close()
      this.$emit('upgrade')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/components';

.selector-trigger-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 10px;

  :deep(> span) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .selector-trigger-label {
    font-size: .7rem;
    color: $muted;
    text-transform: uppercase;
  }
}

.tooltip-selector-icon-wrapper {
  position: relative;

  .tooltip-selector-pro-tag {
    right: -20px;
    top: -12px;
  }
}
</style>
